import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { RichTextRendererComponent } from '../../../rich-text-renderer/rich-text-renderer.component';

@Component({
    selector: 'app-notification-details',
    templateUrl: './notification-details.component.html',
    styleUrls: ['./notification-details.component.scss'],
    imports: [RichTextRendererComponent]
})
export class NotificationDetailsComponent implements OnInit {

  constructor(
    private api: ApiService,
    @Inject(MatDialogRef) public dialogRef: MatDialogRef<NotificationDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

    ngOnInit(): void {
      if (this.data.activeTab == "notifications"){
        this.api.readNotification(this.data.notification.pushNotificationId).subscribe();
      } else {
        this.api.readAnnouncement(this.data.notification.announcementId).subscribe();
      }
    }
}
